import { render } from "./Documents.vue?vue&type=template&id=116ffb1a&scoped=true&lang=pug"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"

import "./Documents.vue?vue&type=style&index=0&id=116ffb1a&lang=scss&scoped=true"
import "./Documents.vue?vue&type=style&index=1&id=116ffb1a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116ffb1a"]])

export default __exports__